// Shared reason taxonomy surfaced through ReasonPicker across the remove,
// pin, exclude, and reorder flows. The ticket names this REMOVE_REASONS, but
// the same list serves every flow since they answer the same audit question:
// "why is this stop being touched?".
//
// "Other" requires a free-text follow-up — see requiresFreeText().

export const REASON_OTHER = 'other';

export const REMOVE_REASONS = [
  { value: 'fridge_closed', label: 'Fridge closed' },
  { value: 'access_issue', label: 'Access issue' },
  { value: 'time_window_conflict', label: 'Time window conflict' },
  { value: 'traffic_road_closure', label: 'Traffic / road closure' },
  { value: 'customer_request', label: 'Customer request' },
  { value: 'capacity_optimization', label: 'Capacity optimization' },
  { value: 'equipment_failure', label: 'Equipment failure' },
  { value: REASON_OTHER, label: 'Other' },
];

// Carryover deselect reasons (SCT-692 AC): why a carryover stop should NOT
// be rerouted today. "Other" requires a free-text note via requiresFreeText.
export const MISSED_STOP_EXCLUSION_REASONS = [
  { value: 'access_issue', label: 'Access issue' },
  { value: 'closed', label: 'Closed' },
  { value: 'food_discarded', label: 'Food discarded' },
  { value: REASON_OTHER, label: 'Other' },
];

export function requiresFreeText(reasonValue) {
  return reasonValue === REASON_OTHER;
}

// Human-readable label for a stored reason value. Falls back to the raw
// value (then an em dash) when the value isn't in the list — read-only
// consumers like UpdateRouteModal use this to render captured reasons.
export function reasonLabel(value, options = REMOVE_REASONS) {
  const match = options.find((r) => r.value === value);
  return match ? match.label : value || '—';
}

// A reason entry is complete when a value is picked, AND if it's "Other",
// a non-empty free-text note is present.
export function isReasonComplete({ value, note } = {}) {
  if (!value) return false;
  if (requiresFreeText(value)) return Boolean(note && note.trim());
  return true;
}
